import TrainingsAPI  from "@/services/api/exercise/api-trainings"
import CategoryDTO from "@/DTO/exercise/training-categoryDTO"
export default {
  namespaced: true,

  state: () => ({
    items: null
  }),

  mutations: {
    set(state, items) {
      state.items = items
    }
  },

  actions: {
    async list({state, commit}, params) {
      try {
        if(params && params.cache && state.items) return state.items
        let res = await TrainingsAPI.categoriesList()
        res = res.map(city => new CategoryDTO(city))
        commit('set', res)
        return res
      } catch (error) {
        console.log(error)
        return Promise.reject(error)
      }
    },
  }
}